<template>
    <div class="max-size coral-light-color card-border image-supplier">
        <img
            v-if="supplier?.imageLink" alt=""
            :src="`https://app.octopusorder.com${supplier.imageLink}`"
            class="max-size card-border"
        />
        <ion-icon
            v-else-if="supplier?.iconType"
            :src="`assets/icon/${supplier.iconType}.svg`"
            class="max-size card-border"
        />
        <ion-icon
            v-else
            alt=""
            src="assets/icon/deliverer.svg"
            class="max-size card-border"
        />
    </div>
</template>

<script setup lang="ts">
import { IonIcon } from "@ionic/vue";
import { computed } from "vue";

import { useSupplierStore } from "@/stores/suppliers";

import { Supplier } from "@/types/supplier";

const props = defineProps<{ supplierId: string }>()

const supplierStore = useSupplierStore()

const supplier = computed<Supplier | undefined>(() => supplierStore.supplierById(props.supplierId))
</script>

<style scoped>
.image-supplier {
    max-height: 92px;
    max-width: 92px;
    height: 92px;
    width: 92px;
    min-width: 92px
}

.image-supplier.web-image {
    max-height: 140px;
    max-width: 140px;
    min-width: 140px;
    min-height: 140px;
}
</style>
